export default "__VITE_PUBLIC_ASSET__6f3afe6b__"